import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=3a37d6fb&scoped=true"
import script from "./order-detail.vue?vue&type=script&lang=ts"
export * from "./order-detail.vue?vue&type=script&lang=ts"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=3a37d6fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37d6fb",
  null
  
)

export default component.exports